// extracted by mini-css-extract-plugin
module.exports = {"container":"Section5_container__-kr6u","layer":"Section5_layer__35Qv7","button":"Section5_button__3OIv7","playerWrapper":"Section5_playerWrapper__3p8cQ"};